// Interfaces
import { IBaseAlertProps } from './interfaces'

// Antd
import { Alert } from 'antd'

const BaseAlert = (props: IBaseAlertProps) => {
  return <Alert {...props} showIcon />
}

export { BaseAlert }
